// extracted by mini-css-extract-plugin
export default {"startScreen":"Start_startScreen__AdTEj","active":"Start_active__8feWl","gameTitle":"Start_gameTitle__8xGJB","gameSelect":"Start_gameSelect__-5nCR"};